"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WildcardUtilsClient = void 0;
const ExecutionEnvironmentUtils_1 = require("@gt/common-utils/build/general/ExecutionEnvironmentUtils");
const pullstate_1 = require("pullstate");
function wrapTaskFunctionEndpoint(endpoint, name = "") {
    return async (args) => {
        if (name.length > 0) {
            console.log(`Running async action "${name}"`, args);
        }
        if (ExecutionEnvironmentUtils_1.ExecutionEnvironmentUtils.isNode()) {
            endpoint = endpoint.bind({ session: undefined });
        }
        const response = await endpoint(args);
        if (name.length > 0) {
            console.log(`Finished async action "${name}"`);
        }
        return response.positive
            ? (0, pullstate_1.successResult)(response.payload, [response.endId, ...response.endTags], response.endMessage)
            : (0, pullstate_1.errorResult)([response.endId, ...response.endTags], response.endMessage, response.errorPayload);
    };
}
/*function wrapTaskFunctionEndpointDirect<A, R>(
  endpoint: (args: A) => Promise<ITaskFunctionResponse<R>>,
  name: string = "",
): Promise<R> {
  return async args => {
    if (name.length > 0) {
      console.log(`Running (direct) async action "${name}"`);
    }

    const response = await endpoint(args);

    if (!response.positive) {
      throw new TaskFunctionError()
    }
  };
}*/
function wrapAuthenticatedTaskFunctionEndpoint(endpoint, name = "") {
    return async (args, { UserStore }) => {
        // console.log(rest);
        if (name.length > 0) {
            console.log(`Running (authed) async action "${name}"`);
        }
        if (ExecutionEnvironmentUtils_1.ExecutionEnvironmentUtils.isNode()) {
            const jwt = UserStore.getRawState().jwt;
            endpoint = endpoint.bind({ __at: jwt, session: undefined });
        }
        /*
        if (jwt) {
    
        }*/
        const response = await endpoint(args);
        return response.positive
            ? (0, pullstate_1.successResult)(response.payload, [response.endId, ...response.endTags], response.endMessage)
            : (0, pullstate_1.errorResult)([response.endId, ...response.endTags], response.endMessage);
    };
}
exports.WildcardUtilsClient = {
    wrapTaskFunctionEndpoint,
    wrapAuthenticatedTaskFunctionEndpoint,
};
